import React from "react";
import { MONEDAS } from "../propuestaComercialGenerator";
import { soloDigitosCelular } from "./constantes";

const EconomicaModal = ({
  firmante,
  setFirmante,
  moneda,
  setMoneda,
  tieneIVA,
  setTieneIVA,
  errorEconomica,
  generandoEconomica,
  economicaBlob,
  firmanteCompleto,
  onCancelar,
  onConfirmar,
}) => {
  return (
    <div className="docgen-revision-overlay" role="dialog" aria-modal="true">
      <div className="docgen-revision-modal docgen-firmante-modal">
        <div className="docgen-revision-header">
          <h2 className="docgen-revision-title">Datos de la propuesta técnico-económica</h2>
          <p className="docgen-revision-subtitle">
            El firmante y la moneda se comparten con la propuesta comercial
            y pueden cambiar en cada proyecto.
          </p>
        </div>
        <div className="docgen-revision-body">
          <input
            type="text"
            className="docgen-name-input"
            placeholder="Nombre completo"
            value={firmante.nombre}
            onChange={(event) =>
              setFirmante((prev) => ({ ...prev, nombre: event.target.value }))
            }
            autoFocus
          />
          <input
            type="text"
            className="docgen-name-input"
            placeholder="Puesto"
            value={firmante.puesto}
            onChange={(event) =>
              setFirmante((prev) => ({ ...prev, puesto: event.target.value }))
            }
          />
          <input
            type="email"
            className="docgen-name-input"
            placeholder="Correo"
            value={firmante.correo}
            onChange={(event) =>
              setFirmante((prev) => ({ ...prev, correo: event.target.value }))
            }
          />
          <input
            type="text"
            className="docgen-name-input"
            placeholder="Celular"
            inputMode="numeric"
            maxLength={10}
            value={firmante.celular}
            onChange={(event) =>
              setFirmante((prev) => ({
                ...prev,
                celular: soloDigitosCelular(event.target.value),
              }))
            }
          />

          <div className="docgen-empresa-label">Moneda</div>
          <p className="orgproc-card-desc">
            Define en qué moneda se expresan los precios de la propuesta.
          </p>
          <div className="docgen-moneda-selector" role="radiogroup" aria-label="Moneda">
            {Object.keys(MONEDAS).map((codigo) => (
              <button
                key={codigo}
                type="button"
                role="radio"
                aria-checked={moneda === codigo}
                className={
                  "docgen-moneda-option" +
                  (moneda === codigo ? " docgen-moneda-option--activa" : "")
                }
                onClick={() => setMoneda(codigo)}
              >
                {MONEDAS[codigo].nombre} ({codigo})
              </button>
            ))}
          </div>

          <div className="docgen-empresa-label">I.V.A.</div>
          <p className="orgproc-card-desc">
            Define si el monto mostrado ya incluye el I.V.A. o si el
            I.V.A. se agrega aparte (con su propio renglón del 16% en la
            tabla de costos).
          </p>
          <div className="docgen-moneda-selector" role="radiogroup" aria-label="IVA">
            <button
              type="button"
              role="radio"
              aria-checked={tieneIVA}
              className={"docgen-moneda-option" + (tieneIVA ? " docgen-moneda-option--activa" : "")}
              onClick={() => setTieneIVA(true)}
              title="El monto no incluye I.V.A.: se agrega un renglón aparte con el 16%."
            >
              I.V.A. no incluido
            </button>
            <button
              type="button"
              role="radio"
              aria-checked={!tieneIVA}
              className={"docgen-moneda-option" + (!tieneIVA ? " docgen-moneda-option--activa" : "")}
              onClick={() => setTieneIVA(false)}
              title="El monto ya incluye el I.V.A.: no se agrega un renglón aparte."
            >
              I.V.A. incluido
            </button>
          </div>

          {errorEconomica && (
            <p className="docgen-output-hint docgen-output-hint--error">{errorEconomica}</p>
          )}
        </div>
        <div className="docgen-revision-footer">
          <button
            type="button"
            className="docgen-cancel-btn"
            onClick={onCancelar}
            disabled={generandoEconomica}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={
              "orgproc-card-btn" +
              (firmanteCompleto && !generandoEconomica ? "" : " orgproc-card-btn--disabled")
            }
            disabled={!firmanteCompleto || generandoEconomica}
            onClick={onConfirmar}
          >
            {generandoEconomica
              ? "Generando..."
              : economicaBlob
              ? "Regenerar propuesta técnico-económica"
              : "Generar propuesta técnico-económica"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EconomicaModal;
